import { createContext } from 'react';

export type ApprovalInboxCtx = {
  showUnapprovedTransactions: boolean;
  showApprovalInboxErrorAlert: boolean;
  approvalInboxError: string;
};

const ApprovalInboxDialogueContext = createContext<ApprovalInboxCtx>({
  showUnapprovedTransactions: false,
  showApprovalInboxErrorAlert: false,
  approvalInboxError: '',
});

export default ApprovalInboxDialogueContext;
